<template>
  <div class="layout">
    <NavigationBar />
    <slot name="sub-header"></slot>
    <slot name="body"></slot>
  </div>
</template>

<script>
  export default {
    name: 'layout',
  };
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Layout.vue?429f0f89